/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForDropDown,
    GetReturnQuantitiesDetails,
    GetApprovedProductPriceByDateForReOrder,
    SaveGenerateOrder,
    SaveGenerateReturnOrderSum,
    GetReturnQuantitiesSumDetails
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetReturnQuantitiesDetails(model) {
    const response = await CommonPost('/api/ReturnOrder/GetReturnQuantitiesDetails', null, model);
    return response.data;
}

async function GetApprovedProductPriceByDateForReOrder(date) {
    const response = await CommonGet('/api/ProductPrice/GetApprovedProductPriceByDateForReOrder', 'date=' + date);
    return response.data;
}

async function SaveGenerateOrder(data) {
    const response = await CommonPost('/api/ReturnOrder/SaveGenerateReturnOrder', null, data);
    return response;
}

async function SaveGenerateReturnOrderSum(data) {
    const response = await CommonPost('/api/ReturnOrder/SaveGenerateReturnOrderSum', null, data);
    return response;
}

async function GetReturnQuantitiesSumDetails(date) {
    const response = await CommonGet('/api/ReturnOrder/GetReturnQuantitiesSumDetails', 'date=' + date);
    return response.data;
}
